import React from 'react';
import {Card, CardContent, CardContentProps, CardHeader, Theme} from '@mui/material';
import {SxProps} from '@mui/system';

export const PWMCard = Card;
export const PWMCardHeader = CardHeader;
export const PWMCardContent: React.FC<CardContentProps> = (props) => {
  const {children} = props;
  const sx: SxProps<Theme> = {...props.sx, py: 1};
  return (
    <CardContent sx={sx}>
      {children}
    </CardContent>
  );
};
